import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Reviews from "../Components/Reviews";
import EquipmentPopup from "../Components/EquipmentPopup";
import "./Home.css";
import Test from "../Components/Test";
import Map from "../Components/Map";

function Home() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="home">
      {showPopup && <EquipmentPopup onClose={closePopup} />}
      <Header />

      <main>
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <h1>Des souvenirs à partager, des émotions à capturer</h1>
              <p className="hero-subtitle">
                Transformez vos événements en souvenirs impérissables avec notre
                photobooth
              </p>
              <a href="/book" className="cta-button">
                Réservez maintenant
              </a>
            </div>
            <div className="hero-image">
              <img
                src="https://i.postimg.cc/nVYPYfPw/4.png"
                alt="WoodyBooth en action"
              />
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features">
          <div className="container">
            <h2>Une expérience photo unique</h2>
            <p className="section-subtitle">
              Notre WoodyBooth allie élégance et fonctionnalité pour créer des
              moments inoubliables
            </p>

            <div className="Home__wrapper">
              <div className="Home__leftblock">
                <ul className="features-list">
                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M21 11.5C21.8284 11.5 22.5 12.1716 22.5 13V19C22.5 20.3807 21.3807 21.5 20 21.5H4C2.61929 21.5 1.5 20.3807 1.5 19V13C1.5 12.1716 2.17157 11.5 3 11.5H21Z" />
                        <path d="M20.5 11.5V7C20.5 5.61929 19.3807 4.5 18 4.5H6C4.61929 4.5 3.5 5.61929 3.5 7V11.5" />
                        <path d="M17 8.5H13.5" />
                        <path d="M10.5 16.5H13.5" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>400 impressions</h3>
                      <p>
                        Jusqu'à 400 tirages par soirée, pour que chacun reparte
                        avec son souvenir
                      </p>
                    </div>
                  </li>

                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z" />
                        <path d="M18.5 4.5H5.5C3.84315 4.5 2.5 5.84315 2.5 7.5V16.5C2.5 18.1569 3.84315 19.5 5.5 19.5H18.5C20.1569 19.5 21.5 18.1569 21.5 16.5V7.5C21.5 5.84315 20.1569 4.5 18.5 4.5Z" />
                        <path d="M4.5 8.5H2.5" />
                        <path d="M4.5 15.5H2.5" />
                        <path d="M21.5 8.5H19.5" />
                        <path d="M21.5 15.5H19.5" />
                        <path d="M12 16.5V19.5" />
                        <path d="M12 4.5V7.5" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>Photos numériques</h3>
                      <p>
                        Recevez toutes vos photos en haute définition après
                        l'événement
                      </p>
                    </div>
                  </li>

                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M4 5.5H20" />
                        <path d="M6.5 5.5V18.5C6.5 19.6046 7.39543 20.5 8.5 20.5H15.5C16.6046 20.5 17.5 19.6046 17.5 18.5V5.5" />
                        <path d="M9 5.5V3.5H15V5.5" />
                        <path d="M14.5 9.5L9.5 14.5" />
                        <path d="M9.5 9.5L14.5 14.5" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>Personnalisation</h3>
                      <p>
                        Cadres sur mesure selon votre thème et
                        vos couleurs
                      </p>
                    </div>
                  </li>

                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M14.5 3.5H9.5C8.39543 3.5 7.5 4.39543 7.5 5.5V18.5C7.5 19.6046 8.39543 20.5 9.5 20.5H14.5C15.6046 20.5 16.5 19.6046 16.5 18.5V5.5C16.5 4.39543 15.6046 3.5 14.5 3.5Z" />
                        <path d="M12 18.5H12.01" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>Photos GIF</h3>
                      <p>
                        Capturez des moments animés pour encore plus de fun et
                        d'originalité
                      </p>
                    </div>
                  </li>

                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M8.5 14.5L12 18.5L15.5 14.5" />
                        <path d="M12 18.5V9.5" />
                        <circle cx="12" cy="5.5" r="2" />
                        <path d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>Hauteur ajustable</h3>
                      <p>
                        S'adapte parfaitement à tous vos invités et à votre
                        espace
                      </p>
                    </div>
                  </li>

                  <li className="feature-item">
                    <div className="feature-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="36"
                        height="36"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z" />
                        <path d="M12 8.5V15.5" />
                        <path d="M15.5 12H8.5" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h3>Installation simple</h3>
                      <p>
                        Montage facile et rapide pour que vous profitiez
                        pleinement de votre événement
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="Home__rightblock">
                <div className="Home__rightblock__img">
                  <img src="https://i.postimg.cc/gk3bzK9L/IMG.png" alt="" />
                </div>
              </div>
            </div>
            <div className="price-banner">
              <div className="price-content">
                <p className="price-tag">
                  Dès <span>200€</span> la soirée
                </p>
                <p className="price-description">
                  Offre spéciale pour les réservations anticipées
                </p>
              </div>
              <a href="/book" className="price-button">
                Réserver
              </a>
            </div>
          </div>
        </section>

        {/* Rental Equipment Section */}
        <section className="rental-equipment">
          <div className="container">
            <h2>Découvrez aussi en location</h2>
            <p className="section-subtitle">
              Complétez votre événement avec notre matériel de sonorisation et d'ambiance
            </p>

            <div className="equipment-grid">
              <div className="equipment-card">
                <div className="equipment-image">
                  <img src={require("../img/JBL 710 PNG.webp")} alt="JBL PartyBox 710" />
                </div>
                <div className="equipment-info">
                  <h3>JBL PartyBox 710</h3>
                  <p className="equipment-specs">800 W – Bluetooth et micros</p>
                  <p className="equipment-price">À partir de <span>50€</span>/jour</p>
                </div>
              </div>

              <div className="equipment-card">
                <div className="equipment-image">
                  <img src={require("../img/Double enceinte JBL 710 PNG.png")} alt="Double enceinte JBL 710" />
                </div>
                <div className="equipment-info">
                  <h3>Double enceinte JBL 710</h3>
                  <p className="equipment-specs">2 x 800 W – Configuration stéréo</p>
                  <p className="equipment-price">À partir de <span>80€</span>/jour</p>
                </div>
              </div>

              <div className="equipment-card">
                <div className="equipment-image">
                  <img src={require("../img/Stroboscope PNG.png")} alt="Stroboscope 1500W" />
                </div>
                <div className="equipment-info">
                  <h3>Stroboscope 1500W</h3>
                  <p className="equipment-specs">DMX – Effets lumineux professionnels</p>
                  <p className="equipment-price">À partir de <span>20€</span>/jour</p>
                </div>
              </div>

              <div className="equipment-card">
                <div className="equipment-image">
                  <img src={require("../img/Smog Machine PNG.png")} alt="Machine à fumée 1500W" />
                </div>
                <div className="equipment-info">
                  <h3>Machine à fumée 1500W</h3>
                  <p className="equipment-specs">DMX – Avec liquide (4L)</p>
                  <p className="equipment-price">À partir de <span>40€</span>/jour</p>
                </div>
              </div>
            </div>

            <div className="rental-cta">
              <a href="/book" className="rental-button">
                Réservez ici !
              </a>
            </div>
          </div>
        </section>

        <Map />
        <br />
        <br />
        <br />
        {/* Reviews Section */}
        <section className="testimonials">
          <div className="container">
            <h2>Ce que nos clients disent</h2>
            <p className="section-subtitle">
              Découvrez les expériences vécues avec notre WoodyBooth
            </p>

            <Reviews />
            <a href="/gallery" className="gallery-link">
              Voir notre galerie d'événements
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M5 12H19" />
                <path d="M12 5L19 12L12 19" />
              </svg>
            </a>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta">
          <div className="container">
            <h2>Prêt à créer des souvenirs inoubliables?</h2>
            <p>
              Réservez dès maintenant votre WoodyBooth et offrez une expérience
              unique à vos invités
            </p>
            <div className="cta-buttons">
              <a href="/book" className="cta-primary">
                Réserver maintenant
              </a>
              <a href="/pricing" className="cta-secondary">
                Voir les tarifs
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Home;
